import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { usePermission } from "@/shared/hooks/usePermission";

interface ProtectedRouteProps {
	children: ReactNode;
	/** Talab qilinadigan permission, `"users:read"` ko'rinishida. */
	requirePermission?: string;
}

/**
 * Permission qorovuli. Autentifikatsiya `RootRoute` da tekshiriladi — bu
 * komponent faqat ruxsatni tekshiradi.
 */
export function ProtectedRoute({ children, requirePermission }: ProtectedRouteProps) {
	const navigate = useNavigate();
	const { permissions } = usePermission();

	const ruxsatYoq = requirePermission ? !permissions.includes(requirePermission) : false;

	useEffect(() => {
		if (ruxsatYoq) {
			navigate({ to: "/dashboard", replace: true });
		}
	}, [ruxsatYoq, navigate]);

	if (ruxsatYoq) {
		return null;
	}

	return <>{children}</>;
}
